import React from 'react';
import { useSelector, useDispatch } from 'react-redux'
import axios from "axios";
import { setBnText, setEnText, setEntity, setResult } from '../audio-recorder/asrSlice'
import Button from 'react-bootstrap/Button';
import { hideLoader, showLoader } from '../loader/loaderSlice';
import { Feedback } from '../feedback';

const AsrNLP = () => {
    const dispatch = useDispatch();
    const bnText = useSelector((state) => state.asr.bnText);
    const appToken = useSelector((state) => state.auth.appToken);

    const updateBnText = (input) => {
        dispatch(setBnText(input))
    }

    const translate = async (input) => {
        dispatch(showLoader());
        axios
            .post(`${process.env.REACT_APP_BACKEND_URL}/api/translate-for-nlp`, input, {
                headers: {
                    "Content-Type": "text/plain",
                    "X-API-KEY": appToken
                },
            })
            .then((response) => {
                // handle the response
                console.log(response);
                dispatch(setBnText(response.data.bnInput));
                dispatch(setEnText(response.data.enInput));
                dispatch(setResult(response.data.userProfiles));
                dispatch(hideLoader());

            })
            .catch((error) => {
                // handle errors
                console.log(error);
                dispatch(hideLoader());
            });
    }
    
    return (
        <div className='asr mini-card'>
            <h4>ASR</h4>
            <div>
                <textarea
                    value={bnText}
                    rows="3" style={{"width": "100%"}}
                    onChange={(e) => updateBnText(e.target.value)} />
            </div>           
            <div>
                <Button
                    variant="outline-dark"  size="sm" onClick={(e) => translate(bnText)}>Submit</Button>
                <Feedback 
                    type = {"asr"} />                
            </div>
        </div>
    );
};


export default AsrNLP;